import React from 'react';
export function PicIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__67bc2__clip0)"
  }, React.createElement("path", {
    d: "M6 11a2 2 0 100-4 2 2 0 000 4z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3h24v18H0V3zm2 2v13.178L7.609 13h1.305l1.112 1.111L16.607 8h1.307L22 12.086V5H2zm20 14H4.058l4.174-3.854 1.742 1.742 7.26-6.74L22 14.914V19z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__67bc2__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}